const escapeHtml = (value) => {
    if (value === null || value === undefined) return "";
    return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
};

module.exports = {
    escapeHtml
};



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/htmlEscapeHelper.js
// module id = 142
// module chunks = 2 4